// Shrinks photos in the browser before upload so registering a listing doesn't
// sit for ages pushing multi-megabyte phone photos to the server. Photos are
// scaled down to fit MAX_DIMENSION and re-encoded as JPEG; the result is only
// used when it's actually smaller. GIF/SVG (animation/vectors) and anything
// that fails to decode are uploaded unchanged.
const MAX_DIMENSION = 1600;
const JPEG_QUALITY = 0.82;

export const shrinkImage = async (file: File): Promise<File> => {
    if (!file.type.startsWith('image/') || /gif|svg/i.test(file.type)) return file;
    try {
        const bitmap = await createImageBitmap(file);
        const scale = Math.min(1, MAX_DIMENSION / Math.max(bitmap.width, bitmap.height));
        const width = Math.round(bitmap.width * scale);
        const height = Math.round(bitmap.height * scale);
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        if (!ctx) return file;
        // White background so transparent PNG logos don't turn black as JPEG.
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, width, height);
        ctx.drawImage(bitmap, 0, 0, width, height);
        bitmap.close?.();
        const blob: Blob | null = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', JPEG_QUALITY));
        if (!blob || blob.size >= file.size) return file;
        const name = file.name.replace(/\.[^.]+$/, '') + '.jpg';
        return new File([blob], name, { type: 'image/jpeg', lastModified: Date.now() });
    } catch {
        return file;
    }
};
